<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime: 2026-07-13 15:46:42
 * @LastEditors: hexy 913752270@qq.com
 * @Description  : 
 * @FilePath     : \icps_fb\src\views\platform\ICPS\internetSales\projectManagement.vue
-->
<!--
 * @Description: 工程登记
 * @Author: wangwangwang
 * @Date: 2020-08-17 15:52:03
 * @LastEditors  : yangxr
 * @LastEditTime : 2022-08-16 10:45:20
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <div class="tabtop">
          <div v-for="(item, index) in navlist" :key="index" @click="choose(item.id)">
            <div :class="currenindex == index + 1 ? 'active' : 'text'">{{ item.value }}</div>
            <div v-if="currenindex !== index + 1 && currenindex !== index + 2 && index !== 3" class="hr"></div>
          </div>
        </div>
        <!-- <div class="header_right" @click="showCardNav = !showCardNav">
          <div class="title">搜索</div>
          <div>
            <div
              :class="{
                arrowTransform: !showCardNav,
                arrowTransformReturn: showCardNav,
              }"
            >
              <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
            </div>
          </div>
        </div>
        <div v-show="showCardNav" class="hr"></div> -->
        <el-collapse-transition>
          <div v-show="showCardNav">
            <div class="search">
              <span slot="label">业务类型</span>
              <el-select v-model="tableParam.businessTypeId" placeholder="请选择" @change="gettableData()">
                <el-option label="市场扩展" value="1"></el-option>
                <el-option label="非市场扩展" value="2"></el-option>
                <el-option label="自用业务" value="3"></el-option>
                <el-option label="往来业务" value="4"></el-option>
                <el-option label="大营销（外协）" value="5"></el-option>
                <el-option label="大营销（协外）" value="6"></el-option>
                <el-option label="现金业务" value="7"></el-option>
              </el-select>
              <span style="display: inline-block; margin-bottom: 10px">
                <span style="margin-right: 12px">工程名称</span>
                <el-input v-model="tableParam.name" style="width: 200px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
              </span>
              <span style="display: inline-block; margin-bottom: 10px">
                <span style="margin-right: 12px">负责人</span>
                <el-input v-model="tableParam.principal" style="width: 200px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
              </span>
              <span style="display: inline-block; margin-bottom: 10px">
                <span style="margin-right: 12px">联系人</span>
                <el-input v-model="tableParam.roadworklInkman" style="width: 200px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
              </span>
              <span style="display: inline-block; margin-bottom: 10px">
                <span style="margin-right: 12px">执行阶段</span>
                <el-select v-model="tableParam.executePhase" style="width: 200px" placeholder="请选择" clearable>
                  <el-option label="委托交底" value="1"></el-option>
                  <el-option label="评估" value="2"></el-option>
                  <el-option label="投标" value="3"></el-option>
                  <el-option label="合同交底" value="4"></el-option>
                </el-select>
              </span>
              <span style="display: inline-block; margin-bottom: 10px">
                <span style="margin-right: 12px">销售部门</span>
                <el-select v-model="tableParam.placeTypeIds" style="width: 200px" placeholder="请选择" multiple clearable>
                  <el-option v-for="(item, index) in saleDepList" :key="index" :label="item.itemName" :value="item.id"></el-option>
                </el-select>
              </span>
              <span style="display: inline-block; margin-bottom: 10px">
                <span style="margin-right: 12px">登记时间</span>
                <el-date-picker
                  v-model="startTimDateEndTimDate"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  unlink-panels
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  @change="(tableParam.startDate = startTimDateEndTimDate[0] || ''), (tableParam.endDate = startTimDateEndTimDate[1] || '')"
                ></el-date-picker>
              </span>
              <!-- <span style="margin-left: 24px;">
                <span style="margin-right: 12px;">施工单位</span>
                <el-input v-model="tableParam.roadwork" style="width: 20%;max-width: 200px;" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
              </span> -->
              <el-button icon="el-icon-search" size="medium" class="bottom_all but1" @click="(tableParam.page = 1), gettableData()">查 询</el-button>
              <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
              <!-- <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="tableParamType = true">高级搜索</el-button> -->
            </div>
          </div>
        </el-collapse-transition>
        <div class="hr"></div>
        <div class="card">
          <div class="card_nav">
            <div>
              <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'SHENGCHANCHUDENGJIGC') !== -1" size="small" class="bottom_all" style="margin-left: 0" @click="fromDate2TypeTrue()">
                <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                生产处登记工程
              </el-button>
              <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'XIAOSHOUCHUDENGJIGC') !== -1" size="small" class="bottom_all" @click="changeVisited('', true, false)">
                <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                销售处登记工程
              </el-button>
            </div>
            <div>
              <el-button size="small" class="bottom_all" style="margin-left: 0" @click="load()"> 导 出 </el-button>
            </div>
          </div>
          <div v-loading="tableLoading" class="card_info" :style="{height:screenHeight-510}">
            <el-table
              :header-cell-style="{ background: '#f3f6f9' }"
              :cell-style="{ borderRight: 'none' }"
              border
              stripe
              style="width: 100%"
              :height="screenHeight - 510"
              :data="tableData"
              tooltip-effect="dark"
              @selection-change="handleSelectionChange"
            >
              <template v-for="(item, index2) in table">
                <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :min-width="item.width">
                  <template slot-scope="scope">
                    <span v-if="item.label == '工程名称'">
                      <span v-if="scope.row.dataType == 2" style="color: #008200; cursor: pointer" @click="sumbit2Modify(scope.row, true)">{{ scope.row.name }}</span>
                      <span v-else style="color: #008200; cursor: pointer" @click="datails(scope.row)">{{ scope.row.name }}</span>
                    </span>
                    <div v-else-if="item.label == '业务类型'">
                      <span v-if="scope.row.dataType == 2">{{ scope.row.businesName }}</span>
                      <span v-else>
                        <el-select v-model="scope.row.businessTypeId" placeholder="请选择" style="width: 130px" @change="changBusinessType(scope.row)">
                          <el-option label="市场扩展" value="1"></el-option>
                          <el-option label="大营销（外协）" value="5"></el-option>
                          <el-option label="大营销（协外）" value="6"></el-option>
                        </el-select>
                      </span>
                    </div>
                    <div v-else-if="item.label == '执行阶段'">
                      <span v-if="scope.row.dataType == 2"></span>
                      <span v-else>
                        <el-select
                          v-model="scope.row.executePhase"
                          :disabled="(scope.row.executePhase === 1 && scope.row.entrustStatus != 0) || (scope.row.executePhase === 4 && scope.row.contractStatus != 0) || scope.row.undertakingStage * 1 != 2 || !scope.row.acceptanceProbabilityId || !scope.row.mortarProbabilityId"
                          style="width: 100%"
                          placeholder="请选择"
                          @change="changstatus(scope.row)"
                        >
                          <el-option v-for="(item, index) in executePhaselist" :key="index" :label="item.itemName" :value="item.id"></el-option>
                        </el-select>
                      </span>
                    </div>
                    <div v-else-if="item.label == '承接概率'">
                      <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'CENGJIEGAILV') !== -1" style="margin: 5px 0; color: rgb(9, 145, 9)" type="text" size="mini" @click="acceptance(scope.row)">承接概率</el-button>
                      <!-- <span v-else>{{ scope.row.acceptanceProbability ? scope.row.acceptanceProbability : '未填写' }}</span> -->
                    </div>
                    <div v-else-if="item.label == '承接阶段'">
                      <span v-if="scope.row.dataType == 2"></span>
                      <span v-else-if="(scope.row.dataType == 1 && currenindex == 1) || (scope.row.dataType == 1 && currenindex == 3)">
                        <el-select
                          v-model="scope.row.undertakingStage"
                          :disabled="
                             (scope.row.executePhase === 4 && scope.row.contractStatus != 0) || (scope.row.undertakingStage == 4 && scope.row.executePhase) || !scope.row.acceptanceProbabilityId || !scope.row.mortarProbabilityId
                          "
                          style="width: 100%"
                          placeholder="请选择"
                          @change="changundertakingStage(scope.row)"
                        >
                          <el-option v-for="(item, index) in undertakingStagelist" :key="index" :label="item.itemName" :value="item.id"></el-option>
                        </el-select>
                      </span>
                      <span v-else>
                        <el-select v-model="scope.row.undertakingStage" disabled style="width: 100%" placeholder="请选择" @change="changundertakingStage(scope.row)">
                          <el-option v-for="(item, index) in undertakingStagelist" :key="index" :label="item.itemName" :value="item.id"></el-option>
                        </el-select>
                      </span>
                    </div>
                    <div v-else-if="item.label == '是否复核'">
                      <el-select
                        v-model="scope.row.review"
                        placeholder="请选择"
                        style="width: 100%"
                        @change="changeReviewStatus(scope.row)"
                      >
                        <el-option label="未复核" :value="0"></el-option>
                        <el-option label="已复核" :value="1"></el-option>
                        <el-option label="已销项" :value="2"></el-option>
                      </el-select>
                    </div>
                    <div v-else-if="item.label == '状态'">
                      <span v-if="scope.row.dataType == 2">生产处登记</span>
                      <span v-else>
                        <span v-if="scope.row.executePhase == 1">
                          {{ ["待登记", "待审核", "审核中", "未通过", "已通过"][scope.row.entrustStatus * 1] }}
                        </span>
                        <span v-if="scope.row.executePhase == 2">
                          {{ ["待登记", "待审核", "评估中", "未通过", "已通过"][scope.row.assessStatus * 1] }}
                        </span>
                        <span v-if="scope.row.executePhase == 3">
                          {{ ["", "投标中", "已中标", "未中标"][scope.row.bidStatus * 1] }}
                        </span>
                        <span v-if="scope.row.executePhase == 4">
                          {{ ["待登记", "待审核", "审核中", "未通过", "已通过"][scope.row.contractStatus * 1] }}
                        </span>
                      </span>
                    </div>
                    <div v-else-if="item.label == '操作'">
                      <el-dropdown :hide-on-click="false" trigger="click">
                        <el-button size="mini" class="bottom_one">更多</el-button>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item v-if="ButtonList.some(res => res.buttonValue == 'YIJIAOGC')">
                            <el-button :disabled="(scope.row.executePhase === 1 && scope.row.entrustStatus != 0) || (scope.row.executePhase === 4 && scope.row.contractStatus != 0)" style="margin: 5px 0" class="bottom_one" size="mini" @click="hanldeSure(scope.row)"> 移交 </el-button>
                          </el-dropdown-item>
                          <el-dropdown-item v-if="scope.row.dataType == 1 && ButtonList.some(res => res.buttonValue == 'XIUGAI')">
                            <el-button style="margin: 5px 0" class="bottom_one" :disabled="(scope.row.executePhase === 1 && scope.row.entrustStatus != 0) || (scope.row.executePhase === 4 && scope.row.contractStatus != 0)" size="mini" @click="changeVisited(scope.row, true, true)"> 修改 </el-button>
                          </el-dropdown-item>
                          <el-dropdown-item v-if="scope.row.dataType == 2 && ButtonList.some(res => res.buttonValue == 'XIUGAI')">
                            <el-button style="margin: 5px 0" class="bottom_one" :disabled="(scope.row.executePhase === 1 && scope.row.entrustStatus != 0) || (scope.row.executePhase === 4 && scope.row.contractStatus != 0)" size="mini" @click="sumbit2Modify(scope.row)"> 修改 </el-button>
                          </el-dropdown-item>
                          <el-dropdown-item v-if="ButtonList.some(res => res.buttonValue == 'SHANCHU')">
                            <el-button
                              style="margin: 5px 0"
                              class="bottom_one"
                              :disabled="(scope.row.executePhase === 1 || scope.row.executePhase === 4) && (scope.row.entrustStatus === 4 || scope.row.contractStatus === 4)"
                              size="mini"
                              @click="deleteDisclose(scope.row)"
                            >
                              删除
                            </el-button>
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                    <span v-else>{{ scope.row[item.prop] }}</span>
                  </template>
                </el-table-column>
              </template>
              <!-- <el-table-column align="center" prop="businesName" label="业务类型" min-width="140"></el-table-column> -->
              <!-- <el-table-column align="center" prop="roadwork" label="施工单位" min-width="140"></el-table-column>
              <el-table-column align="center" prop="roadworklInkman" label="联系人" min-width="140"></el-table-column>
              <el-table-column align="center" prop="roadworkPhone" label="联系电话" min-width="140"></el-table-column> -->
              <!-- <el-table-column align="center" prop="giveUpReason" label="放弃理由" min-width="140"></el-table-column> -->
            </el-table>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination
            :current-page.sync="tableParam.page"
            :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            layout="prev,pager,sizes,next,jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="gettableData()"
          ></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- 添加工程 -->
    <regproject ref="cz" :status="visited" :sendData="visitedata" type="0" :executePhaseType="executePhaseType" @close="close" @sumbit="sumbit"></regproject>
    <!-- 查看详情 -->
    <el-dialog v-dialogDrag :visible.sync="show" width="1085px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">工程信息</span>
      <div class="dialoginfo show">
        <el-form :inline="true" label-width="110px" disabled>
          <div class="form-title">工程基本信息</div>
          <el-form-item prop="name">
            <span slot="label" style="color: #ff0000">工程名称</span>
            <el-input v-model="fromDate.name" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item prop="expectedAmount" label-width="160px">
            <span slot="label" style="color: #ff0000">预估用砼量（万方）</span>
            <el-input
              v-model="fromDate.expectedAmount"
              style="width: 176px"
              placeholder="请输入"
              onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
              @input="fromDate.expectedAmount = $regExp.checkNum(fromDate.expectedAmount)"
              @blur="fromDate.expectedAmount = $regExp.blurCheckNum(fromDate.expectedAmount)"
            ></el-input>
          </el-form-item>
          <el-form-item prop="roadworkType">
            <span slot="label" style="color: #ff0000">合同单位类型</span>
            <el-select v-model="fromDate.roadworkType" placeholder="请选择" filterable clearable>
              <el-option v-for="(item, index) in roadworkTypeList" :key="index" :label="item.itemName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="businessTypeId">
            <span slot="label" style="color: #ff0000">业务类型</span>
            <el-select
              ref="businesName"
              v-model="fromDate.businessTypeId"
              placeholder="请选择"
              @change="
                $nextTick(() => {
                  fromDate.businesName = $refs.businesName.selectedLabel;
                })
              "
            >
              <el-option v-for="(item, index) in businessTypeIdList" :key="index" :label="item.itemName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="typeId">
            <span slot="label" style="color: #ff0000">工程性质</span>
            <el-select
              ref="typeId"
              v-model="fromDate.typeId"
              placeholder="请选择"
              @change="
                $nextTick(() => {
                  fromDate.type = $refs.typeId.selectedLabel;
                })
              "
            >
              <el-option v-for="(item, index) in typeIdList" :key="index" :label="item.itemName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="startTime">
            <span slot="label" style="color: #ff0000">混凝土使用时间</span>
            <el-date-picker v-model="fromDate.startTime" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
          <el-form-item prop="placeTypeId">
            <span slot="label" style="color: #ff0000">销售处</span>
            <el-select
              ref="placeTypeId"
              v-model="fromDate.placeTypeId"
              placeholder="请选择"
              @change="
                $nextTick(() => {
                  fromDate.placeType = $refs.placeTypeId.selectedLabel;
                })
              "
            >
              <el-option v-for="(item, index) in saleDepList" :key="index" :label="item.itemName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="mortarServiceTime">
            <span slot="label" style="color: #ff0000">砂浆使用时间</span>
            <el-date-picker v-model="fromDate.mortarServiceTime" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
          <el-form-item prop="concreteUndertaking">
            <span slot="label" style="color: #ff0000">我司混凝土</span>
            <el-input
              v-model="fromDate.concreteUndertaking"
              placeholder="请输入"
              clearable
              onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
              @input="fromDate.concreteUndertaking = $regExp.checkNum(fromDate.concreteUndertaking)"
              @blur="fromDate.concreteUndertaking = $regExp.blurCheckNum(fromDate.concreteUndertaking)"
            >
              <template slot="append">万方</template>
            </el-input>
          </el-form-item>
          <!-- <el-form-item prop="acceptanceProbabilityId">
            <span slot="label" style="color: #ff0000">承接概率</span>
            <el-select
              ref="acceptanceProbabilityId"
              v-model="fromDate.acceptanceProbabilityId"
              placeholder="请选择"
              @change="
                $nextTick(() => {
                  fromDate.acceptanceProbability = $refs.acceptanceProbabilityId.selectedLabel;
                })
              "
            >
              <el-option v-for="(item, index) in cjglList" :key="index" :label="item.itemName" :value="item.id"></el-option>
            </el-select>
          </el-form-item> -->
          <div>
            <el-form-item prop="mortarUndertaking">
              <span slot="label" style="color: #ff0000">砂浆</span>
              <el-input
                v-model="fromDate.mortarUndertaking"
                placeholder="请输入"
                clearable
                onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                @input="fromDate.mortarUndertaking = $regExp.checkNum(fromDate.mortarUndertaking)"
                @blur="fromDate.mortarUndertaking = $regExp.blurCheckNum(fromDate.mortarUndertaking)"
              >
                <template slot="append">万方</template>
              </el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <span slot="label" style="color: #ff0000">地理位置/最近供应站点</span>
              <div style="width: 227px">
                <span v-if="fromDate.place" class="table_link" style="cursor: pointer" @click="selectMapFun()">{{ fromDate.place + "-" + (fromDate.latelyStationName || "") }}</span>
                <span v-else class="table_link" style="cursor: pointer" @click="selectMapFun()">选择</span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">运距</span>
              <el-input v-model="fromDate.haulDistance" disabled placeholder="请输入" clearable>
                <template slot="append">km</template>
              </el-input>
            </el-form-item>
            <el-form-item v-if="fromDate.haulDistance > 30" prop="otherCarShop">
              <span slot="label" style="color: #ff0000">其他供应同行</span>
              <el-input v-model="fromDate.otherCarShop" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <span slot="label" style="color: #ff0000">施工单位</span>
              <el-select
                ref="contractSigningUnitId"
                v-model="fromDate.contractSigningUnitId"
                placeholder="请选择"
                filterable
                clearable
                @change="
                  $nextTick(() => {
                    fromDate.contractSigningUnit = $refs.contractSigningUnitId.selectedLabel;
                  })
                "
              >
                <el-option v-for="(item, index) in roadworkIdList" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <span slot="label">联系人</span>
              <el-input v-model="fromDate.roadworklInkman" placeholder="请输入" clearable></el-input>
            </el-form-item>
            <el-form-item prop="roadworkPhone">
              <span slot="label">电话</span>
              <el-input v-model="fromDate.roadworkPhone" type="Number" placeholder="请输入" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <span slot="label" style="color: #ff0000">建设单位</span>
              <el-select
                ref="constructionUnitId"
                v-model="fromDate.constructionUnitId"
                placeholder="请选择"
                filterable
                clearable
                @change="
                  $nextTick(() => {
                    fromDate.constructionUnit = $refs.constructionUnitId.selectedLabel;
                  })
                "
              >
                <el-option v-for="(item, index) in roadworkIdList" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <span slot="label">联系人</span>
              <el-input v-model="fromDate.cuLinkman" placeholder="请输入" clearable></el-input>
            </el-form-item>
            <el-form-item prop="cuPhone">
              <span slot="label">电话</span>
              <el-input v-model="fromDate.cuPhone" placeholder="请输入" type="Number" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <span slot="label" style="color: #ff0000">小票打印单位</span>
              <el-select
                ref="otherUnitId"
                v-model="fromDate.otherUnitId"
                placeholder="请选择"
                filterable
                clearable
                @change="
                  $nextTick(() => {
                    fromDate.otherUnit = $refs.otherUnitId.selectedLabel;
                  })
                "
              >
                <el-option v-for="(item, index) in roadworkIdList" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <span slot="label">联系人</span>
              <el-input v-model="fromDate.otherUnitLinkman" placeholder="请输入" clearable></el-input>
            </el-form-item>
            <el-form-item prop="otherUnitPhone">
              <span slot="label">电话</span>
              <el-input v-model="fromDate.otherUnitPhone" placeholder="请输入" type="Number" clearable></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item prop="clientTypeId">
              <span slot="label" style="color: #ff0000">机会类型</span>
              <el-select
                ref="clientTypeId"
                v-model="fromDate.clientTypeId"
                placeholder="请选择"
                @change="
                  $nextTick(() => {
                    fromDate.clientType = $refs.clientTypeId.selectedLabel;
                  })
                "
              >
                <el-option v-for="(item, index) in clientTypeIdList" :key="index" :label="item.itemName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="orderGetTypeId">
              <span slot="label" style="color: #ff0000">订单获取方式</span>
              <el-select
                ref="orderGetTypeId"
                v-model="fromDate.orderGetTypeId"
                placeholder="请选择"
                @change="
                  $nextTick(() => {
                    fromDate.orderGetType = $refs.orderGetTypeId.selectedLabel;
                  })
                "
              >
                <el-option v-for="(item, index) in orderGetTypeList" :key="index" :label="item.itemName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <span slot="label">行政区</span>
              <el-cascader ref="address" v-model="fromDate.administrativeDistricts0" style="width: 227px" :options="treeData" filterable @change="administrativeDistrictsFun()"></el-cascader>
            </el-form-item>
            <el-form-item>
              <span slot="label">区域</span>
              <!-- <el-cascader ref="address" v-model="fromDate.region" style="width: 227px" :options="treeData" filterable @change="administrativeDistrictsFun()"></el-cascader> -->
              <el-input v-model="fromDate.region" placeholder="请输入" style="width: 227px" type="Number" clearable></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <span slot="label">管桩工程</span>
              <el-radio-group v-model="fromDate.whetherTubularColumn" style="width: 227px">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="fromDate.whetherTubularColumn == 1">
              <span slot="label">管柱（米）</span>
              <el-input
                v-model="fromDate.tubularColumn"
                placeholder="请输入"
                onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                @input="fromDate.tubularColumn = $regExp.checkNum(fromDate.tubularColumn)"
                @blur="fromDate.tubularColumn = $regExp.blurCheckNum(fromDate.tubularColumn)"
              ></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <span slot="label">装配式工程</span>
              <el-radio-group v-model="fromDate.whetherFabricated" style="width: 227px">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="fromDate.whetherFabricated == 1">
              <span slot="label">装配式</span>
              <el-input v-model="fromDate.fabricated" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item v-if="UserInfo.adminStatus == 1" prop="createUserId" :rules="[{ required: true, message: '请选择负责人', trigger: 'change' }]" class="FZYdanWei">
              <span slot="label">负责人</span>
              <el-cascader
                ref="getCheckedNodes"
                v-model="fromDate.createUserId"
                style="width: 227px"
                :options="principalarr"
                :show-all-levels="false"
                :props="{ value: 'id', label: 'name' }"
                :placeholder="createUserName"
              ></el-cascader>
            </el-form-item>
          </div>
          <el-form-item>
            <span slot="label">备注</span>
            <el-input v-model="fromDate.remark" style="width: 920px" type="textarea" :rows="5" resize="none" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <div v-if="fromDate.id">
            <div>
              <span class="titleTop">跟进记录</span>
            </div>
            <div class="link">
              <div class="linkOne"></div>
              <div class="linkTwo"></div>
            </div>
            <div class="timeline">
              <el-timeline>
                <el-timeline-item v-for="(item, index) in followUpList" :key="index" color="#0bbd87">
                  <div class="line">
                    <div>
                      <span class="lineName">{{ item.createUserName }}</span>
                      <span>{{ item.createTime }} 更新:</span>
                      <el-tag v-if="item.whetherAdopt == 1" type="danger">已采纳</el-tag>
                      <el-tag v-else type="warning">待采纳</el-tag>
                    </div>
                  </div>
                  <div class="lineContent">{{ item.followUpMeesion }}</div>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="show = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 移交 -->
    <personProject :visible="personVisible" @closeModel="closeModel" @getPerson="getPerson" />
    <!-- 高级搜索 -->
    <el-dialog v-dialogDrag :visible.sync="tableParamType" width="650px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">高级搜索</span>
      <div class="dialoginfo"></div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="(tableParamType = false), (tableParam.roadworklInkman = ''), (startTimDateEndTimDate = []), (tableParam.startDate = ''), (tableParam.endDate = ''), (tableParam.executePhase = '')"
          >取 消</el-button
        >
        <el-button class="bottom_all" style="margin-left: 24px" @click="gettableData(), (tableParamType = false)">搜 索</el-button>
      </span>
    </el-dialog>
    <el-dialog v-dialogDrag :visible.sync="fromDate2Type" width="850px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">生产处工程信息</span>
      <div class="dialoginfo">
        <el-form ref="fromDate2" :inline="true" :model="fromDate2" label-width="110px" hide-required-asterisk :rules="rules2" :disabled="fromDate2Disabled">
          <el-row>
            <el-col :span="12">
              <el-form-item v-if="UserInfo.adminStatus == 1" prop="companyId">
                <span slot="label" style="color: #ff0000">公司</span>
                <el-select
                  ref="selection1"
                  v-model="fromDate2.companyId"
                  placeholder="请选择"
                  @change="
                      $nextTick(() => {
                        fromDate2.companyName = $refs.selection1.selectedLabel;
                      })
                  "
                >
                  <el-option v-for="(item, index) in companyIdlist" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="contractSignPartyId">
                <span slot="label" style="color: #ff0000">合同签订主体</span>
                <el-select
                  ref="contractSignPartyId"
                  v-model="fromDate2.contractSignPartyId"
                  placeholder="请选择"
                  @change="
                      $nextTick(() => {
                        fromDate2.contractSignParty = $refs.contractSignPartyId.selectedLabel;
                      })
                  "
                >
                  <el-option v-for="(item, index) in roadWorkList" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item prop="name" :rules="[{ required: true, message: '请输入工程名称', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">工程名称</span>
            <el-input v-model="fromDate2.name" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item prop="place" :rules="[{ required: true, message: '请输入地理位置', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">地理位置</span>
            <el-input v-model="fromDate2.place" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item prop="businessTypeId" :rules="[{ required: true, message: '请选择业务类型', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">业务类型</span>
            <el-select
              ref="businesName"
              v-model="fromDate2.businessTypeId"
              placeholder="请选择"
              @change="
                $nextTick(() => {
                  fromDate2.businesName = $refs.businesName.selectedLabel;
                })
              "
            >
              <el-option v-for="(item, index) in businessTypeIdList" :key="index" :label="item.itemName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="customerId" :rules="[{ required: true, message: '请输入客户名称', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">客户名称</span>

            <el-select
              ref="customerName"
              v-model="fromDate2.customerId"
              placeholder="请选择"
              @change="
                $nextTick(() => {
                  fromDate2.customerName = $refs.customerName.selectedLabel;
                })
              "
            >
              <template v-if="fromDate2.businessTypeId == 2 || fromDate2.businessTypeId == 3 || fromDate2.businessTypeId == 7">
                <el-option v-for="(item, index) in customerIdList" :key="index" :label="item.name" :value="item.id"> </el-option>
              </template>
              <template v-if="fromDate2.businessTypeId == 4">
                <el-option v-for="(item, index) in cooperationCusIdList" :key="index" :label="item.supplierName" :value="item.contractId">
                  <span>{{ item.supplierName }}</span
                  >_<span>{{ item.contractNo }}</span>
                </el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="expectedAmount"
            label-width="160px"
            :rules="[
              {
                required: true,
                message: '请输入预估用砼量',
                trigger: 'change',
              },
            ]"
          >
            <span slot="label" style="color: #ff0000">预估用砼量（方）</span>
            <el-input v-model="fromDate2.expectedAmount" type="Number" style="width: 190px" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item prop="expectedAmount" label-width="111px" :rules="[{ required: true, message: '请选择供应时间', trigger: 'change' }]">
            <span slot="label">供应时间</span>
            <el-date-picker v-model="fromDate2.startTime" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <span slot="label">联系人</span>
            <el-input v-model="fromDate2.roadworklInkman" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item prop="roadworkPhone">
            <span slot="label">电话</span>
            <el-input v-model="fromDate2.roadworkPhone" placeholder="请输入" type="Number" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">是否装配式工程</span>
            <el-select v-model="fromDate2.whetherFabricated" placeholder="请选择">
              <el-option label="否" :value="0"></el-option>
              <el-option label="是" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
              <span slot="label">小票打印单位</span>
              <el-select
                ref="otherUnitId2"
                v-model="fromDate2.otherUnitId"
                placeholder="请选择"
                filterable
                clearable
                @change="
                  $nextTick(() => {
                    fromDate2.otherUnit = $refs.otherUnitId2.selectedLabel;
                  })
                "
              >
                <el-option v-for="(item, index) in roadworkIdList" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item prop="taxRate">
            <span slot="label">税率</span>
            <el-input 
              v-model="fromDate2.taxRate" 
              placeholder="请输入" 
              clearable
              onkeypress="return( /[\d.]/.test(String.fromCharCode(event.keyCode)))"
            ></el-input>
          </el-form-item>
          <el-form-item prop="productSallerId">
            <span slot="label">销售员</span>
            <el-select
              ref="saller"
              v-model="fromDate2.productSallerId"
              placeholder="请选择"
              clearable
              filterable
              @change="
                $nextTick(() => {
                  fromDate2.productSaller = $refs.saller.selectedLabel;
                })
              "
            >
              <el-option v-for="(item, k) in sallerIdList" :key="k" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="placeTypeId">
            <span slot="label">销售员处别</span>
            <el-select
              ref="placeType"
              v-model="fromDate2.placeTypeId"
              placeholder="请选择"
              clearable
              @change="
                $nextTick(() => {
                  fromDate2.placeType = $refs.placeType.selectedLabel;
                })
              "
            >
              <el-option v-for="(item, index) in saleDepList" :key="index" :label="item.itemName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">备注</span>
            <el-input v-model="fromDate2.remark" style="width: 600px" type="textarea" :rows="5" resize="none" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="$refs.fromDate2.resetFields(), (fromDate2Type = false)">关 闭</el-button>
        <el-button v-if="fromDate2Disabled == false" class="bottom_all" style="margin-left: 24px" @click="sumbit2()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog v-dialogDrag :visible.sync="cjgldio" width="500px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">承接概率</span>
      <div class="dialoginfo">
        <el-form :inline="true" :model="cjglfromDate" label-width="110px">
          <el-form-item prop="acceptanceProbabilityId">
            <span slot="label" style="color: #ff0000">混凝土承接概率</span>
            <el-select
              ref="acceptanceProbabilityId"
              v-model="cjglfromDate.acceptanceProbabilityId"
              placeholder="请选择"
              @change="
                $nextTick(() => {
                  cjglfromDate.acceptanceProbability = $refs.acceptanceProbabilityId.selectedLabel;
                })
              "
            >
              <el-option v-for="(item, index) in cjglList" :key="index" :label="item.itemName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="mortarProbabilityId">
            <span slot="label" style="color: #ff0000">砂浆承接概率</span>
            <el-select
              ref="mortarProbabilityId"
              v-model="cjglfromDate.mortarProbabilityId"
              placeholder="请选择"
              @change="
                $nextTick(() => {
                  cjglfromDate.mortarProbability = $refs.mortarProbabilityId.selectedLabel;
                })
              "
            >
              <el-option v-for="(item, index) in cjglList" :key="index" :label="item.itemName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="cjgldio = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="cjglSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import regproject from "./components/regproject.vue";
import personProject from "@/components/ChoisePerson/personProject.vue";
import mixin from "@/mixins/ICPSmixin.js";
import { queryPage, Download, getExecutePhaseStatus, udatePrincipal, customerqueryPage, collaborateCustomers, updateMixRatio, updateEngineering } from "@/api/internetSales/projectManagement.js";
import { saveengineeringManagement, QueryOneByid, queryAllByCompanyId, addFollowUpMession, UpdateFinancialCode,getOrganizationBytypes } from "@/api/internetSales/chanceManagement.js";
import treeData from "@/views/platform/ICPS/basicConfig/address.js";
import { getDicType, getcompany, getDicsType, orgUserTree } from "@/api/common.js";
import { get_simple_user_listBycompanyId } from "@/api/GHnumber/contract";
import { getUserInfo } from "@/utils/auth.js";
export default {
  components: {
    regproject,
    personProject,
  },
  mixins: [mixin],
  data() {
    var landlinePhone = (rule, value, callback) => {
      if (value && !this.$regExp.landlinePhoneReg(value)) {
        return callback(new Error("电话格式错误！"));
      } else {
        callback();
      }
    };
    return {
      followUpList: [],
      /**导航栏*/
      navlist: [
        {
          value: "跟踪中",
          id: 1,
        },
        {
          value: "已承接",
          id: 2,
        },
        {
          value: "已放弃",
          id: 3,
        },
        {
          value: "生产处登记",
          id: 4,
        },
      ],
      table: [],
      table1: [
        { label: "工程编号", width: "140", prop: "code", status: true },
        { label: "工程名称", width: "140", prop: "name", status: true },
        // { label: "业务类型", width: "150", prop: "businesName", status: true },
        { label: "客户类型", width: "150", prop: "clientType", status: true },
        { label: "工程性质", width: "150", prop: "type", status: true },
        { label: "销售分部", width: "auto", prop: "placeType", status: true },
        { label: "地理位置", width: "150", prop: "place", status: true },
        { label: "位置最近供应点", width: "auto", prop: "latelyStationName", status: true },
        { label: "运距", width: "auto", prop: "haulDistance", status: true },
        { label: "混凝土使用时间", width: "200", prop: "startTime", status: true },
        { label: "砂浆使用时间", width: "200", prop: "mortarServiceTime", status: true },
        { label: "承接概率", width: "auto", prop: "acceptanceProbability", status: true },
        { label: "预估我司混凝土承接量（wm³）", width: "150", prop: "concreteUndertaking", status: true },
        { label: "登记时间", width: "200", prop: "createTime", status: true },
        { label: "负责人", width: "140", prop: "principal", status: true },
        { label: "执行阶段", width: "130", prop: "executePhase", status: true },
        { label: "执行阶段修改时间", width: "130", prop: "startDate", status: true },
        { label: "承接阶段", width: "130", prop: "executePhase", status: true },
        { label: "承接阶段修改时间", width: "130", prop: "endDate", status: true },
        { label: "放弃理由", width: "130", prop: "giveUpReason", status: false },
        { label: "状态", width: "130", prop: "", status: true },
        { label: "操作", width: "100", prop: "", status: true },
      ],
      table2: [
        { label: "工程编号", width: "140", prop: "code", status: true },
        { label: "工程名称", width: "140", prop: "name", status: true },
        { label: "业务类型", width: "150", prop: "businesName", status: true },
        { label: "登记时间", width: "200", prop: "createTime", status: true },
        { label: "负责人", width: "140", prop: "principal", status: true },
        { label: "是否复核", width: "120", prop: "review", status: true },
        { label: "执行阶段", width: "130", prop: "executePhase", status: true },
        { label: "执行阶段修改时间", width: "130", prop: "startDate", status: true },
        { label: "状态", width: "130", prop: "", status: true },
        { label: "操作", width: "100", prop: "", status: true },
      ],
      currenindex: 1,
      fromDate2Disabled: false,
      treeData,
      startTimDateEndTimDate: [],
      tableParamType: false,
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      DownloadURL: Download,
      /*表单页类型，0为无树状，1为有树状，有树状在el-main加上display:flex*/
      pagesType: 0,
      /*添加表单数据*/
      executePhaselist: [
        { itemName: "委托交底", id: 1 },
        { itemName: "评估", id: 2 },
        { itemName: "投标", id: 3 },
        { itemName: "合同交底", id: 4 },
      ],
      undertakingStagelist: [
        // { itemName: "放弃", id: 0 },
        // { itemName: "未中标", id: 1 },
        // { itemName: "无效信息", id: 2 },
        // { itemName: "指定供应", id: 3 },
        // { itemName: "已承接", id: 4 },
        // { itemName: "委托办理介入供应", id: 5 },
        { itemName: "已放弃", id: 0 },
        { itemName: "跟踪中", id: 1 },
        { itemName: "已承接", id: 2 },
      ],
      visited: false,
      visitedata: {},
      show: false,
      fromDate: {
        administrativeDistricts:'',
      },
      personVisible: false,
      itemData: {},
      executePhaseType: false,
      roadworkIdList: [],
      businessTypeIdList: [
        // { itemName: "市场扩展", id: "1" },
        { itemName: "非市场扩展", id: "2" },
        { itemName: "自用业务", id: "3" },
        { itemName: "往来业务", id: "4" },
        // { itemName: "大营销（外协）", id: "5" },
        // { itemName: "大营销（协外）", id: "6" },
        { itemName: "现金业务", id: "7" },
      ],
      typeIdList: [],
      rateOfProgressIdList: [],
      UserInfo: "",
      clientTypeIdList: [],
      TreeSelectStypeNumber: 0,
      fromDate2Type: false,
      fromDate2: {
        businessTypeId: "",
        customerId: "",
        startTime: "",
        companyId: "",
        contractSignPartyId:"",
        contractSignParty:"",
        taxRate: "",
        productSallerId: "",
        productSaller: "",
        placeTypeId: "",
        placeType: ""
      },
      rules2: {
        roadworkPhone: [{ validator: landlinePhone, trigger: "change" }],
        // companyId: [{ required: true, message: "请选择公司", trigger: "change" }],
        contractSignPartyId: [{ required: true, message: "请选择合同签订主体", trigger: "change" }],
      },
      customerIdList: [], //生产处客户
      cooperationCusIdList: [], //往来协作客户
      principalarr: [],
      createUserName: "",
      roadworkTypeList: [
        { itemName: "建设单位", id: 1 },
        { itemName: "施工单位", id: 2 },
      ],
      saleDepList: [],
      cjglList: [],
      cjgldio: false,
      cjglfromDate: {
        acceptanceProbabilityId: "",
        acceptanceProbability: "",
        mortarProbabilityId: "",
        mortarProbability: "",
        id: "",
      },
      concreteUndertaking: 0,
      mortarUndertaking: 0,
      companyIdlist: [],
      orderGetTypeList:[],
      roadWorkList:[],
    };
  },
  watch: {
    currenindex: {
      handler() {
        this.tableData = [];
        this.tableParam = {
          ...this.tableParam,
          isAssess: 1,
          roadworklInkman: "",
          placeTypeId:"",
          placeTypeIds:[],
          startDate: "",
          endDate: "",
          executePhase: "",
        };
        this.init();
        if (this.currenindex == 1) {
          this.table = this.table1;
          this.tableParam.undertakingStage = 1;
          this.gettableData();
        }
        if (this.currenindex == 2) {
          this.table = this.table1;
          this.tableParam.undertakingStage = 2;
          this.gettableData();
        }
        if (this.currenindex == 3) {
          this.table = this.table1;
          this.tableParam.undertakingStage = 3;
          this.gettableData();
        }
        if (this.currenindex == 4) {
          this.table = this.table2;
          this.tableParam.undertakingStage = 4;
          this.gettableData();
        }
        //此处为执行的函数或者方法
      },
      deep: false, //是否深度监听，true为是，默认为false
      immediate: true, //immediate表示在watch中首次绑定的时候，是否执行handler,true为执行,默认为false
    },
  },
  async created() {
    this.tableParam = {
      ...this.tableParam,
      isAssess: 1,
      roadworklInkman: "",
      placeTypeId:"",
      placeTypeIds:[],
      startDate: "",
      endDate: "",
      executePhase: "",
    };
    getDicType({ code: "Orderacquisitionmethod" }).then(res => {
      this.orderGetTypeList = res.data.items;
    });
    getDicType({ code: "EngineeringNature" }).then(res => {
      this.typeIdList = res.data.items;
    });
    getDicType({ code: "customerType" }).then(res => {
      this.clientTypeIdList = res.data.items;
    });
    getDicType({ code: "ProjectProgress" }).then(res => {
      this.rateOfProgressIdList = res.data.items;
    });
    getDicType({ code: "CJGL" }).then(res => {
      this.cjglList = res.data.items;
    });
    getDicsType({ codes: "EngineeringNature,contractType,MATname,castingType,shutdownLogo, placeDon, recordFixedPostition, market" }).then(res => {
      if (res.code == 1001 && res) {
        this.saleDepList = res.data.placeDon.items;
      }
    });
    this.UserInfo = await getUserInfo();
    get_simple_user_listBycompanyId({
      roleId: "12b2f6ff304148fd89141e9faa9afb96", // 固定角色ID：销售员
      orgznizationId: this.UserInfo.companyId || this.UserInfo.userCompanyId,
    }).then(res => {
      if (res.code === 1001) {
        this.sallerIdList = res.data;
      }
    });
    this.principalarr = await orgUserTree('',1);
    if (this.UserInfo.adminStatus == 1) {
      /**通过typeId为公司类型id查询所有公司 */
      getcompany({ typeId: "19da56b9e85648059e3cf1e7da497da4" }).then(res => {
        this.companyIdlist = res.data;
      });
    }
    getOrganizationBytypes({ typeId: "19da56b9e85648059e3cf1e7da497da4,110572600018735104" }).then(res => {
      if (res.code === 1001) {
        this.roadWorkList = res.data;
      }
    });
    this.treeData.forEach(v => {
      v.children.map(res => {
        res.children.forEach(res2 => {
          delete res2.children;
        });
      });
    });
    queryAllByCompanyId().then(res => {
      this.roadworkIdList = res.data;
    });
    this.gettableData();
    customerqueryPage({ page: 1, pageSize: 9999 }).then(res => {
      this.customerIdList = res.data.data;
    });
    collaborateCustomers({ contractTypeId: "6" }).then(res => {
      this.cooperationCusIdList = res.data;
      console.log(res, "contractTypeId：“5”");
    });
    if (this.ButtonList.findIndex(res => res.buttonValue == "CENGJIEGAILV") !== -1) {
      this.table1[10].status = true;
    } else {
      this.table1[10].status = false;
    }
  },
  methods: {
    //导出
    load() {
      let params = this.tableParam
      params.undertakingStage = ''
      this.$Download(this.DownloadURL, params);
    },
    cjglSure() {
      console.log(this.cjglfromDate);
      if (!this.cjglfromDate.acceptanceProbabilityId) {
        this.$message.warning("请选择混凝土承接概率！");
        return;
      }
      if (!this.cjglfromDate.mortarProbabilityId) {
        this.$message.warning("请选择砂浆承接概率！");
        return;
      }
      UpdateFinancialCode(this.cjglfromDate).then(res => {
        if (res.code == 1001) {
          this.cjgldio = false;
          this.$message.success("保存成功");
          this.init();
        }
      });
    },
    // 切换是否复核状态
    changeReviewStatus(row) {
      this.$confirm('确定修改复核状态吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        cancelButtonClass: 'bottom_all_two',
        confirmButtonClass: 'bottom_all',
        type: 'warning'
      }).then(() => {
        UpdateFinancialCode({
          id: row.id,
          review: row.review
        }).then(res => {
          if (res.code == 1001) {
            this.$message.success("修改状态成功");
            this.gettableData();
          } else {
            this.gettableData();
          }
        });
      }).catch(() => {
        this.gettableData(); // 取消操作，刷新列表还原数据
      });
    },
    //承接概率
    acceptance(row) {
      this.cjgldio = true;
      this.cjglfromDate.id = row.id;
      this.cjglfromDate.acceptanceProbabilityId = row.acceptanceProbabilityId;
      this.cjglfromDate.acceptanceProbability = row.acceptanceProbability;
      this.cjglfromDate.mortarProbabilityId = row.mortarProbabilityId;
      this.cjglfromDate.mortarProbability = row.mortarProbability;
      this.concreteUndertaking = row.concreteUndertaking;
      this.mortarUndertaking = row.mortarUndertaking;
    },
    /*导航栏切换*/
    choose(num) {
      this.currenindex = num;
      if (num == 3) {
        this.table[18].status = true; //放弃理由的显示
      } else {
        this.table[18].status = false;
      }
    },
    /*移交*/
    hanldeSure(low) {
      this.itemData = {
        id: low.id,
        principal: "",
        principalId: "",
      };
      this.personVisible = true;
    },
    closeModel() {
      this.personVisible = false;
    },
    getPerson(data) {
      this.itemData.principal = data.name;
      this.itemData.principalId = data.id;
      let arr = [];
      arr.push(this.itemData);
      udatePrincipal(arr).then(res => {
        if (res.code === 1001) {
          this.$message.success("移交成功");
          this.gettableData();
          this.personVisible = false;
        }
      });
    },
    init() {
      /*重置数据*/
      this.tableParam.name = "";
      this.tableParam.roadwork = "";
      this.tableParam.roadworklInkman = "";
      this.tableParam.placeTypeId = "";
      this.tableParam.placeTypeIds = [];
      this.tableParam.executePhase = "";
      this.tableParam.startDate = "";
      this.tableParam.endDate = "";
      this.startTimDateEndTimDate = "";
      this.gettableData();
    },
    changeVisited(data, status, executePhaseType) {
      console.log(data);
      this.visited = status;
      this.executePhaseType = executePhaseType;

      this.$refs.cz.disabledflag = false;
      // this.visitedata = this.copy(data);
      QueryOneByid({ id: data.id }).then(res => {
        this.visitedata = this.copy(res.data);
        // this.$refs.cz.cz();
      });
    },
    //删除交底信息
    deleteDisclose(data) {
      var row = data;
      row.status = 0;
      saveengineeringManagement(data).then(res => {
        if (res.code == 1001) {
          this.$message.success("操作成功");
          this.gettableData();
        }
      });
    },
    close() {
      this.visitedata = "";
      this.visited = false;
      this.$refs.cz.initSet();
    },
    sumbit(data) {
      saveengineeringManagement(data).then(res => {
        if (res.code === 1001) {
          console.log(res);
          // if (res.data?.repeat) {
          //   this.$confirm("该工程已登记，是否登记新工程?", "提示", {
          //     confirmButtonText: "登记新工程",
          //     cancelButtonText: "添加更进记录",
          //     cancelButtonClass: "bottom_all_two",
          //     confirmButtonClass: "bottom_all",
          //     type: "warning",
          //   })
          //     .then(() => {
          //       this.changeVisited("", true, false);
          //     })
          //     .catch(() => {
          //       this.changeVisited(res.data.repeat, true);
          //     });
          // } else {
          if (data.id && data.followUpMeesion) {
            addFollowUpMession({
              engineeringId: data.id,
              followUpMeesion: data.followUpMeesion,
              whetherAdopt: 0,
            }).then(res => {
              if (res.code === 1001) {
                this.$refs.cz.initSet();
                this.$message.success("操作成功");
                setTimeout(() => {
                  this.visited = false;
                }, 100);
                this.gettableData();
              }
            });
          } else {
            this.$refs.cz.initSet();
            this.$message.success("操作成功");
            setTimeout(() => {
              this.close();
            }, 100);
            this.gettableData();
          }
        }
        // }
      });
    },
    sumbit2() {
      this.$refs.fromDate2.validate(valid => {
        if (valid) {
          if (this.UserInfo.adminStatus == 1 && !this.fromDate2.companyId) {
            return this.$message.warning("请选择公司！");
          }
          if (!this.fromDate2.companyId) {
            this.fromDate2.companyId = this.UserInfo.companyId;
            this.fromDate2.companyName = this.UserInfo.companyName;
            this.fromDate2.principalId = this.UserInfo.userId;
            this.fromDate2.principal = this.UserInfo.userRealName;
          }
          this.fromDate2.dataType = 2; //1是销售，2是生产处
          console.log(JSON.parse(JSON.stringify(this.fromDate2)));
          saveengineeringManagement(this.fromDate2).then(res => {
            if (res.code === 1001) {
              this.fromDate2Type = false;
              this.$message.success("操作成功");
              this.gettableData();
            }
          });
        }
      });
    },
    sumbit2Modify(row, type) {
      this.fromDate2Disabled = false;
      if (type) {
        this.fromDate2Disabled = type;
      }
      this.fromDate2Type = true;
      this.$data.fromDate2 = this.$options.data().fromDate2;
      QueryOneByid({ id: row.id }).then(res => {
        this.fromDate2 = { ...this.fromDate2, ...res.data };
        if (this.fromDate2.administrativeDistricts) {
          this.fromDate2.administrativeDistricts0 = JSON.parse(this.fromDate2.administrativeDistricts);
        }
      });
    },
    fromDate2TypeTrue() {
      this.fromDate2Type = true;
      this.$nextTick(() => {
        this.$refs.fromDate2.resetFields();
        this.$data.fromDate2 = this.$options.data().fromDate2;
      });
    },
    datails(low) {
      QueryOneByid({ id: low.id }).then(res => {
        this.fromDate = res.data;
        if (this.fromDate.administrativeDistricts) {
          this.fromDate.administrativeDistricts0 = JSON.parse(this.fromDate.administrativeDistricts);
        }
        this.followUpList = res.data.followUpList || [];
        console.log(this.followUpList);
        this.show = true;
      });
    },
    changstatus(low) {
      this.$confirm(`确定切换状态为${["", "委托交底", "评估", "投标", "合同交底"][low.executePhase * 1]}?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          getExecutePhaseStatus({
            id: low.id,
            executePhase: low.executePhase,
          }).then(res => {
            low.executePhaseStatus = res.data;
            this.$router.push({
              name: ["", "projectClarifi", "projectAssess", "internetSalestender", "projectClarifi"][low.executePhase * 1],
            });
          });
          this.$message({
            type: "success",
            message: "切换成功!",
          });
        })
        .catch(() => {
          this.gettableData();
        });
    },
    changundertakingStage(low) {
      console.log(low);
      if (low.undertakingStage == 0) {
        this.$prompt(`工程：${low.name}`, "承接放弃原因", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputErrorMessage: "输入不能为空",
          inputValidator: value => {
            // 点击按钮时，对文本框里面的值进行验证
            if (!value) {
              return "输入不能为空";
            }
          },
        })
          .then(({ value }) => {
            if (!value) {
              this.gettableData();
              return this.$message({
                type: "warning",
                message: "请输入承接放弃原因!",
              });
            }
            updateEngineering({
              id: low.id,
              undertakingStage: low.undertakingStage,
              giveUpReason: value,
            }).then(res => {
              if (res.code == 1001) {
                this.$message({
                  type: "success",
                  message: "操作成功!",
                });
              }
              this.gettableData();
            });
          })
          .catch(() => {
            this.gettableData();
          });
      } else {
        this.$confirm(`确定切换状态为${["已放弃", "跟踪中", "已承接"][low.undertakingStage * 1]}?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "bottom_all_two",
          confirmButtonClass: "bottom_all",
          type: "warning",
        })
          .then(() => {
            updateEngineering({
              id: low.id,
              undertakingStage: low.undertakingStage,
            }).then(res => {
              if (res.code == 1001) {
                this.$message({
                  type: "success",
                  message: "切换成功!",
                });
              }
              this.gettableData();
            });
          })
          .catch(() => {
            this.gettableData();
          });
      }
    },
    changBusinessType(low) {
      this.$confirm(`确定切换状态为${["", "市场扩展", "", "", "", "大营销（外协）", "大营销（协外）"][low.businessTypeId * 1]}?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          low.businesName = ["", "市场扩展", "", "", "", "大营销（外协）", "大营销（协外）"][low.businessTypeId * 1];
          updateMixRatio({
            id: low.id,
            businessTypeId: low.businessTypeId,
            businesName: low.businesName,
          }).then(res => {
            if (res.code == 1001) {
              this.$message({
                type: "success",
                message: "切换成功!",
              });
            }
          });
        })
        .catch(() => {
          this.gettableData();
        });
    },
    TreeSelectStypeFun() {
      if (this.TreeSelectStypeNumber === 0) {
        this.TreeSelectStypeNumber = 1;
        setTimeout(() => {
          const dom = document.body.lastChild;
          dom.style.zIndex = "10000";
        }, 1000);
      }
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.show {
  padding: 0 !important;

  .el-input,
  .el-select {
    width: 227px;
  }

  .dialoginfo {
    padding: 0;
  }

  .form-title {
    font-size: 18px;
    margin: 10px 0;
  }
}

.el-input,
.el-select {
  width: 240px;
}

.project-name {
  font-size: 18px;
}

.accout-container {
  margin: 10px 0;

  .accout-list {
    margin: 10px 0;
  }
}

.form-title {
  font-size: 18px;
  margin: 10px 0;
}

.table_link {
  margin-left: 10px;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.8;
}

.tabtop {
  width: 761px;
}
</style>
